module.exports = __webpack_public_path__ + "img/bank-008-koreaixport.44cb1c3f.svg";